module.exports = __webpack_public_path__ + "assets/img/logitech-becomethenextcreator-w960.ee544010.jpg";